export default [
  {
    path: '/plans/rain/list',
    name: 'plans.rain.list',
    component: () => import('@/views/modules/plans/rain-plan/ListRainPlans'),
    meta: {
      module: 'plans.rain',
      pageTitle: 'List All Rain Plans',
      breadcrumb: [
        { text: 'List Rain Plans', active: true, },
        { text: 'Create Plan', to: {name: 'plans.rain.create'} }
      ],
    }
  },


  {
    path: '/plans/rain/create',
    name: 'plans.rain.create',
    component: () => import('@/views/modules/plans/rain-plan/CreateRainPlan'),
    meta: {
      module: 'plans.rain',
      pageTitle: 'Plan Create',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.rain.list'} },
        { text: 'Create Plan' , active: true}
      ],
    }
  },


  {
    path: '/plans/rain/:id/edit',
    name: 'plans.rain.edit',
    component: () => import('@/views/modules/plans/rain-plan/EditRainPlan'),
    meta: {
      module: 'plans.rain',
      pageTitle: 'Rain Suction Plan Edit',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.rain.list'} },
        { text: 'Create Plan' , to: {name: 'plans.rain.create'}},
        { text: 'Edit Plan' , active: true}
      ],
    }
  },
]
